import React from 'react';
import { Text as UiText } from '@ui-component-library';
import { TailwindWrapper } from '@utils/TailwindWrapper';
import { cn } from '@utils/cn';
import * as Opt from '../Helpers';

export function getTextVariantUiProps(textVariants, textVariant) {
    let uiProps = Opt.textVariantRowsToUiProps(textVariants);
    if (!uiProps && textVariant) {
        uiProps = { variant: textVariant };
    }
    return uiProps && uiProps.variant ? uiProps : null;
}

export default function TextVariant({
    textVariants,
    textVariant,
    as = 'div',
    spacing = [],
    align,
    text,
    children,
    className,
    wrapperStyle,
    innerClassName,
    useQuillTypography = true,
    innerStyle,
    ...additionalProps
}) {
    const uiProps = getTextVariantUiProps(textVariants, textVariant);
    if (!uiProps) {
        return null;
    }

    return (
        <div style={wrapperStyle ?? { overflow: 'hidden' }} className={className}>
            <TailwindWrapper>
                <UiText
                    variant={uiProps.variant}
                    sm={uiProps.sm}
                    md={uiProps.md}
                    lg={uiProps.lg}
                    xl={uiProps.xl}
                    twoXl={uiProps.twoXl}
                    as={as}
                    style={innerStyle}
                    className={cn(
                        useQuillTypography && 'quill-text quill-text-inherit-typography',
                        Opt.CalculateSpacing(spacing),
                        align,
                        innerClassName
                    )}
                    {...additionalProps}
                >
                    {children ?? <span dangerouslySetInnerHTML={{ __html: text }} />}
                </UiText>
            </TailwindWrapper>
        </div>
    );
}
